/* eslint-disable react/require-default-props */
/* eslint-disable react/destructuring-assignment */
import { Button, Grid, Group, Modal, Paper, Space } from '@mantine/core';
import PageSection from '../../../../components/core/PageSection/PageSection';
import PageViewProperty from '../../../../components/core/PageViewProperty/PageViewProperty';
import { EntityTypeType, UnitOfMeasureType } from '../../../../models/core/cache.type';
import {
  ProposalResiduePlanQuotationTreatmentType,
  ProposalResiduePlanTreatmentType,
  ProposalTipoPrecificacaoEnum,
} from '../../../../models/core/proposals.type';
import { Feature } from '../../../../utils/constants.utils';
import ResidueQuotationTreatmentForm from './ResidueQuotationTreatmentForm';

type Props = {
  opened: boolean;
  onClose: () => void;
  modoEdicao: boolean;
  requireSupplier?: boolean;
  referenceData: {
    entityTypeData?: EntityTypeType[];
    unitOfMeasures: UnitOfMeasureType[];
  };
  origItem: ProposalResiduePlanQuotationTreatmentType | null;
  item: ProposalResiduePlanQuotationTreatmentType | null;
  refItem: ProposalResiduePlanTreatmentType;
  idPropostaResiduoPlanoCotacao?: number;
  defaultActiveKey?: string;
  zIndex: number;
  callback?: (
    item: ProposalResiduePlanQuotationTreatmentType | null,
    refItem: ProposalResiduePlanTreatmentType | null,
    action: string,
    confirmed: boolean
  ) => void;
};

export default function ResidueQuotationTreatmentModal(props: Props) {
  let modalActionLabel = 'Adicionar';
  if (props.item) {
    modalActionLabel = props.modoEdicao ? 'Editar' : 'Visualizar';
  }

  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      title={`Cotação/Tratamento - ${modalActionLabel}`}
      size="70%"
      zIndex={props.zIndex}
      closeOnClickOutside={false}
      closeOnEscape={false}
    >
      <Paper shadow="xs" p="md" withBorder>
        <Paper shadow="xs" p="md" withBorder>
          <PageSection
            size="lg"
            color={Feature.Home.Proposal.color}
            label="Cotação para:"
            text="Este é o tratamento a ser cotado."
          />
          <Space h="xs" />
          <Grid columns={4}>
            <Grid.Col span={2}>
              <PageViewProperty label="Tratamento" text={props.refItem?.residuoTratamento || '-'} size="sm" />
            </Grid.Col>
            <Grid.Col span={1}>
              <PageViewProperty
                label="Autorização Ambiental?"
                text={props.refItem?.autorizacaoAmbiental ? 'Sim' : 'Não'}
                size="sm"
              />
            </Grid.Col>
          </Grid>
        </Paper>
        <Space h="lg" />
        <ResidueQuotationTreatmentForm
          modoEdicao={props.modoEdicao}
          referenceData={props.referenceData}
          origItem={props.origItem}
          item={props.item}
          refItem={props.refItem}
          idPropostaResiduoPlanoCotacao={props.idPropostaResiduoPlanoCotacao}
          defaultActiveKey={props.defaultActiveKey}
          zIndex={props.zIndex}
          requireSupplier={props.requireSupplier}
          hideCustomerSection={props.refItem.precificacao?.tipo === ProposalTipoPrecificacaoEnum.Geral}
          callback={(item, refItem, action, confirmed) => {
            props.callback?.(item, refItem, action, confirmed);
            if (confirmed) {
              props.onClose();
            }
          }}
        />
      </Paper>
      <Space h="xl" />
      <Group justify="right">{!props.modoEdicao && <Button onClick={props.onClose}>Fechar</Button>}</Group>
    </Modal>
  );
}
